import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

type PageMetaProps = {
  titleKey: string;
  descriptionKey: string;
};

export function PageMeta({ titleKey, descriptionKey }: PageMetaProps) {
  const { t, i18n } = useTranslation();
  const title = t(titleKey);
  const description = t(descriptionKey);
  const lang = i18n.language?.startsWith('en') ? 'en' : 'el';

  useEffect(() => {
    document.title = title;
    document.documentElement.lang = lang;

    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'description');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', description);
  }, [title, description, lang]);

  return null;
}
